export default "__VITE_ASSET__cwLVCB7w__"